import { ReactNode } from 'react';
import { ProLogo } from 'src/components/common/ProLogo';
import { HamburgerMenuIcon } from 'src/svgs';

import * as styles from './MobileTopBar.css';

type MobileTopBarProps = {
  toggleMenu: () => void;
  /** Optional right-aligned action, mirroring the desktop header slot */
  rightContent?: ReactNode;
};

export const MobileTopBar = ({
  toggleMenu,
  rightContent,
}: MobileTopBarProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.icon} onClick={toggleMenu}>
        <HamburgerMenuIcon />
      </div>
      <div className={styles.logoContainer}>
        <ProLogo />
      </div>
      <div className={styles.rightContentContainer}>{rightContent}</div>
    </div>
  );
};
